import { gql } from 'apollo-angular';
import {
  addressFragment,
  commodityFragment,
  hazardousMaterialFragment,
  tableUserFragment,
} from '@services/queries/fragments/lighthouse.fragments';

export const shipmentTableFragment = gql`
  fragment ShipmentTable on Shipment {
    id
    status
    freightTransportationMode
    equipmentType
    freightClass
    weight
    pieces
    footage
    truckMiles
    totalCommodities
    hasHazardousMaterials
    trackingStarted
    tarpSize
    isPaid
    co2Emissions
    truckNumber
    trailerNumber
    electronicLoggingDevice
    vinNumber
    itrackerReferenceId
    originPlace
    originRegion
    originRegionCode
    originCountry
    originPostcode
    originFacilityName
    originAppointmentAt
    originAppointmentAtUtc
    originAppointmentTimezone
    originAppointmentType
    destinationPlace
    destinationRegion
    destinationRegionCode
    destinationCountry
    destinationPostcode
    destinationFacilityName
    destinationAppointmentAt
    destinationAppointmentAtUtc
    destinationAppointmentTimezone
    destinationAppointmentType
    bolNumber
    proNumber
    pickupNumber
    quoteNumber
    mbolNumber
    concatenatedReferences
    containerNumber
    bookingNumber
    sealNumber
    vesselNumber
    voyageNumber
    oceanCarrierIdentifier
    deliveryType
    drayageDeliveryMode
    containerArrivalLocation
    etaAtUtc
    deliveredAtUtc
    releasedAtUtc
    invoicedAtUtc
    carrierInvoicedAtUtc
    carrierPaidAtUtc
    paidAtUtc
    gateOutAtUtc
    gateInAtUtc
    lastFreeDayAtUtc
    availableForPickupAtUtc
    atFinalDestinationPortAtUtc
    leftLoadingPortAtUtc
    etaPortAtUtc
    droppedOnYardAtUtc
    readyOnYardAtUtc
    pickedUpFromYardAtUtc
    createdAt
    updatedAt
    deletedAt
    createdByUser {
      ...TableUserFragment
    }
    updatedByUser {
      ...TableUserFragment
    }
    deletedByUser {
      ...TableUserFragment
    }
    team {
      id
      name
    }
    alertSummary {
      total
      highestActiveSeverity
    }
  }
  ${tableUserFragment}
`;

export const shipmentStopProfileFragment = gql`
  fragment ShipmentStopProfile on ShipmentStop {
    id
    type
    order
    facilityName
    appointmentAt
    appointmentTimezone
    appointmentType
    appointmentNotes
    appointmentOpenAt
    arrivedAt
    departedAt
    completedAt
    geofenceRadiusFeet
    facilityPhoneNumber
    facilityEmail
    facilityContactFullName
    address {
      ...AddressFragment
    }
    references {
      id
      type
      value
    }
    accessorialServices {
      id
      type
      note
    }
  }
  ${addressFragment}
`;

export const shipmentProfileFragment = gql`
  fragment ShipmentProfile on Shipment {
    id
    status
    freightTransportationMode
    equipmentType
    freightClass
    weight
    pieces
    footage
    truckMiles
    declaredValue
    lineHaulRate
    co2Emissions
    description
    billOfLadingInstructions
    isPaid
    trackingStarted
    hasHazardousMaterials
    totalCommodities
    itrackerReferenceId
    truckNumber
    trailerNumber
    electronicLoggingDevice
    vinNumber
    tarpLength
    tarpWidth
    tarpSize
    temperatureMin
    temperatureMax
    temperaturePrecool
    temperatureUnit
    temperatureHumidity
    temperatureHandlingRequirements
    bookingNumber
    containerNumber
    containerArrivalLocation
    deliveryType
    drayageDeliveryMode
    sealNumber
    oceanCarrierIdentifier
    vesselNumber
    voyageNumber
    mbolNumber
    quoteNumber
    bolNumber
    pickupNumber
    proNumber
    concatenatedReferences
    archiveReason
    archiveNotes
    lockedUntil
    originRegion
    originRegionCode
    originPlace
    originCountry
    originPostcode
    originFacilityName
    originAppointmentAt
    originAppointmentAtUtc
    originAppointmentTimezone
    originAppointmentType
    destinationRegion
    destinationRegionCode
    destinationPlace
    destinationCountry
    destinationPostcode
    destinationFacilityName
    destinationAppointmentAt
    destinationAppointmentAtUtc
    destinationAppointmentTimezone
    destinationAppointmentType
    etaAtUtc
    releasedAtUtc
    invoicedAtUtc
    carrierInvoicedAtUtc
    carrierPaidAtUtc
    paidAtUtc
    gateOutAtUtc
    gateInAtUtc
    lastFreeDayAtUtc
    availableForPickupAtUtc
    atFinalDestinationPortAtUtc
    leftLoadingPortAtUtc
    etaPortAtUtc
    startedAtUtc
    deliveredAtUtc
    droppedOnYardAtUtc
    readyOnYardAtUtc
    pickedUpFromYardAtUtc
    createdAt
    updatedAt
    deletedAt
    shipper {
      id
      name
      phoneNumber
      email
      billingEmail
      address
    }
    team {
      id
      name
      type
    }
    createdByUser {
      ...TableUserFragment
    }
    updatedByUser {
      ...TableUserFragment
    }
    deletedByUser {
      ...TableUserFragment
    }
    lockedByUser {
      ...TableUserFragment
    }
    stops {
      ...ShipmentStopProfile
    }
    references {
      id
      type
      value
    }
    shipmentTimestamps {
      id
      type
      occurredAt
      occurredAtTimezone
      occurredAtDate
      occurredAtTime
    }
    hazardousMaterials {
      ...HazardousMaterialFragment
    }
    commodities {
      ...CommodityFragment
    }
    ltlQuoteRequest {
      id
      status
      bookedLtlQuote {
        id
        carrierName
      }
    }
    alertSummary {
      total
      highestActiveSeverity
    }
  }
  ${tableUserFragment}
  ${shipmentStopProfileFragment}
  ${hazardousMaterialFragment}
  ${commodityFragment}
`;
